module.exports = __webpack_public_path__ + "img/info-success.e916bcd5.svg";